import { DisbursementEnhanced } from '@percent/admin-dashboard/api/actions/disbursements/disbursements.types'

export type ConfirmBeneficiaryModalProps = {
  isOpen: boolean
  onClose: () => void
  disbursement: DisbursementEnhanced
  refreshData: (() => void) | null
}

export enum ConfirmBeneficiaryStatus {
  SUCCESS = 'success',
  ERROR = 'error'
}
